<div class="modal-container">
  <button
    id="modalGlosario"
    #modalGlosario
    data-bs-toggle="modal"
    data-bs-target="#modalGlosarioForm"
    hidden="hidden"
    hidden
    aria-hidden="true"
    tabindex="-1">
    Launch
  </button>
  <div
    class="modal fade"
    id="modalGlosarioForm"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="modalTitle">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ (isEditar ? 'glosario.editar_glosario' : 'glosario.crear_glosario') | translate }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body" *ngIf="isEditar; else saveGlosario">
          <form [formGroup]="formularioEditar" (ngSubmit)="onGuardarEdicion()">
            <div class="mb-4">
              <label for="concepto" class="form-label"
                >{{ 'glosario.concepto' | translate }} :</label
              >
              <input
                id="concepto"
                class="form-control"
                formControlName="concepto" />
            </div>
            <div class="mb-4">
              <label for="definicion" class="form-label">
                {{ 'glosario.definicion' | translate }} :
              </label>
              <textarea
                id="definicion"
                class="form-control"
                rows="5"
                formControlName="definicion"></textarea>
            </div>
            <div class="modal-footer">
              <button
                type="submit"
                data-bs-dismiss="modal"
                [disabled]="formularioEditar.invalid"
                class="btn btn-govco fill-btn-govco my-2"
                aria-label="Guardar">
                {{ 'glosario.guardar' | translate }}
              </button>
              <button
                type="button"
                class="btn btn-govco outline-btn-govco my-2"
                data-bs-dismiss="modal"
                aria-label="Cancelar">
                {{ 'glosario.cancelar' | translate }}
              </button>
            </div>
          </form>
        </div>
        <ng-template #saveGlosario>
          <div class="modal-body">
            <form [formGroup]="formularioGuardar" (ngSubmit)="onGuardarGlosario()">
              <div class="mb-4">
                <label for="entidadId" class="form-label"
                  >{{ 'glosario.entidad' | translate }} :</label
                >
                <select
                  id="entidadId"
                  class="form-select"
                  formControlName="entidadId">
                  <option value="" disabled>
                    {{ 'glosario.seleccione_opcion' | translate }}
                  </option>
                  <option value="{{ entidad.id }}" *ngFor="let entidad of entidades">
                    {{ entidad.entidad }}
                  </option>
                </select>
              </div>
              <div class="mb-4">
                <label for="termino" class="form-label"
                  >{{ 'glosario.concepto' | translate }} :</label
                >
                <input
                  id="termino"
                  class="form-control"
                  formControlName="termino" />
              </div>
              <div class="mb-4">
                <label for="definicion" class="form-label">
                  {{ 'glosario.definicion' | translate }} :
                </label>
                <textarea
                  id="definicion"
                  class="form-control"
                  rows="5"
                  formControlName="definicion"></textarea>
              </div>
              <div class="modal-footer">
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  [disabled]="formularioGuardar.invalid"
                  class="btn btn-govco fill-btn-govco my-2"
                  aria-label="Guardar">
                  {{ 'glosario.guardar' | translate }}
                </button>
                <button
                  type="button"
                  class="btn btn-govco outline-btn-govco my-2"
                  data-bs-dismiss="modal"
                  aria-label="Cancelar">
                  {{ 'glosario.cancelar' | translate }}
                </button>
              </div>
            </form>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
